// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Routing utama. Tambah route baru boleh; jangan hapus route existing
//                  tanpa approval.
// =============================================================================

import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RealtimeProvider } from "@/context/RealtimeContext";
import { Toaster } from "@/components/ui/sonner";
import { AppShell, allowedFor } from "@/components/AppShell";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Produk from "@/pages/Produk";
import WorkOrder from "@/pages/WorkOrder";
import WorkOrderDetail from "@/pages/WorkOrderDetail";
import PermintaanBarang from "@/pages/PermintaanBarang";
import RekapMoU from "@/pages/RekapMoU";
import RekapStockRealTime from "@/pages/RekapStockRealTime";
import QrTrackingPage from "@/pages/QrTrackingPage";
import LaporanMutasi from "@/pages/LaporanMutasi";
import QrScannerPage from "@/pages/QrScannerPage";
import PairScan from "@/pages/PairScan";
import Gudang from "@/pages/Gudang";
import Stok from "@/pages/Stok";
import Retur from "@/pages/Retur";
import TransferGudang from "@/pages/TransferGudang";
import PengirimanStore from "@/pages/PengirimanStore";
import SuratJalan from "@/pages/SuratJalan";
import Penjualan from "@/pages/Penjualan";
import Invoice from "@/pages/Invoice";
import Penagihan from "@/pages/Penagihan";
import Laporan from "@/pages/LaporanBulanan";
import UserManagement from "@/pages/UserManagement";
import AuditTrail from "@/pages/AuditTrail";
import Backup from "@/pages/Backup";
import Panduan from "@/pages/Panduan";
import SOP from "@/pages/SOP";
import V2App from "@/v2/V2App";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

const PendingNotice = () => (
  <div className="max-w-md mx-auto mt-10 text-center">
    <h2 className="text-xl font-semibold font-display">Menunggu Penetapan Role</h2>
    <p className="text-muted-foreground mt-2">Akun Anda berhasil login namun belum memiliki role. Hubungi Owner/Admin ETAMS untuk diberikan akses.</p>
  </div>
);

function AppRoutes() {
  return (
    <Routes>
      {/* ETAMSINV adalah app utama. Route canonical TANPA /v2.
          V1 (MongoDB) tidak dirender (kode V1 tetap utuh sebagai backup, tak disentuh). */}
      {/* Legacy V1 spesifik -> canonical */}
      <Route path="/produk" element={<Navigate to="/merchandise" replace />} />
      <Route path="/surat-jalan" element={<Navigate to="/arsip" replace />} />
      {/* Legacy /v2/* -> hapus prefix /v2 (address bar jadi tanpa /v2) */}
      <Route path="/v2/*" element={<LegacyV2Redirect />} />
      {/* App utama ETAMSINV di root (auth & session dikelola di dalam V2App) */}
      <Route path="/*" element={<V2App />} />
    </Routes>
  );
}

// Redirect kompatibilitas: /v2, /v2/dashboard, /v2/work-orders, ... -> tanpa /v2.
function LegacyV2Redirect() {
  const loc = useLocation();
  const rest = loc.pathname.replace(/^\/v2/, "");
  const target = (!rest || rest === "/") ? "/dashboard" : rest;
  return <Navigate to={target + loc.search} replace />;
}

export default function App() {
  return (
    <div className="App">
      {/* SLICE S-H/S-I (B5): latar solid dari .app-bg::after (opak penuh). Gambar
          /brand/login-bg.png DIHENTIKAN — selalu tertutup overlay opak, jadi
          mengunduhnya sia-sia (boros) di kedua tema. */}
      <div className="app-bg" aria-hidden="true" />
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
